import api from '../../utils/api';
import store from '../index';
import authStore from './auth';

const state = {
	klumpTranxRef: null,
	selectedBankPartner: null
};

const getters = {
	getKlumpTranxRef: (state) => state.klumpTranxRef,
	getSelectedBankPartner: (state) => state.selectedBankPartner
};

const mutations = {
	setKlumpTranxRef: (state, data) => {
		state.klumpTranxRef = data;
	},
	setSelectedBankPartner: (state, data) => {
		state.selectedBankPartner = data;
	}
};
const actions = {
	async klumpFetchApi({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		return api.get(`${data.api}`, data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setIsLoading', false);
				if (response && response.data && response.data.token) {
					const token = response && response.data && response.data.token ? response.data.token : null;
					await commit('setUserPartnerToken', token);
				}
				commit('addPreviousModal', store.state.nextModal);
				commit('setNextModal', response.next_step);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},

	async klumpPostApi({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		return api.post(`${data.api}`, data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setIsLoading', false);
				if (response?.data?.token) {
					commit('updateToken', response?.data?.token);
				}
				if (response && response.data && response.data.token) {
					const token = response && response.data && response.data.token ? response.data.token : null;
					await commit('setUserPartnerToken', token);
				}
				if (response && response.next_step && response.next_step.token) {
					await commit('setUserPartnerToken', response.next_step.token);
				}
				if (response.next_step.name === 'PAYMENT_LINK') {
					commit('setKlumpTranxRef', response.data.reference);
				}
				if (response.message.includes('Existing')) {
					await commit('setNewUser', true);
				}
				commit('addPreviousModal', store.state.nextModal);
				commit('setNextModal', response.next_step);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},


	async queryKlumpTransactionStatus({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		return api.get(`${data.api}`, data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setQueryTransactionStatus', response.message);
				if (response.is_completed) {
					commit('setIsLoading', false);
					commit('addPreviousModal', store.state.nextModal);
					commit('setNextModal', { ...response });
					if (response.success) {
						commit('setIframeResponseOnSuccess', {
							status: true,
							type: 'SUCCESS',
							data: {
								status: 'successful',
								data: {
									reference: state.klumpTranxRef,
									redirect_url: authStore.state.payload.redirect_url
										? authStore.state.payload.redirect_url
										: false
								}
							}
						});
					} else {
						commit('setIframeResponseOnError', {
							message: response.message,
							type: 'ERROR'
						});
					}
				}
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	}
};

export default {
	state,
	getters,
	mutations,
	actions
};

